export default __webpack_public_path__ + "static/media/button-login.fc972ef8.svg";